import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#EAE3D6',
      light: '#F0EBE3',
      dark: '#C8BFB0',
    },
    secondary: {
      main: '#C4785D',
      light: '#D4937A',
      dark: '#A65D42',
    },
    background: {
      default: '#131210',
      paper: '#1B1916',
    },
    text: {
      primary: '#EAE3D6',
      secondary: '#9E9189',
      disabled: '#6B6159',
    },
    divider: 'rgba(234, 227, 214, 0.08)',
    action: {
      hover: 'rgba(234, 227, 214, 0.05)',
      selected: 'rgba(234, 227, 214, 0.08)',
      disabledBackground: 'rgba(234, 227, 214, 0.06)',
      disabled: 'rgba(234, 227, 214, 0.3)',
    },
  },
  typography: {
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: {
      fontFamily: "'Instrument Serif', Georgia, 'Times New Roman', serif",
      fontWeight: 400,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: "'Instrument Serif', Georgia, 'Times New Roman', serif",
      fontWeight: 400,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontFamily: "'Instrument Serif', Georgia, 'Times New Roman', serif",
      fontWeight: 400,
      letterSpacing: '-0.01em',
    },
    h4: {
      fontFamily: "'Instrument Serif', Georgia, 'Times New Roman', serif",
      fontWeight: 400,
    },
    h5: {
      fontWeight: 600,
      letterSpacing: '-0.015em',
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    body1: {
      letterSpacing: '-0.01em',
      lineHeight: 1.7,
    },
    body2: {
      letterSpacing: '-0.01em',
      lineHeight: 1.65,
    },
    button: {
      letterSpacing: '-0.01em',
    },
    caption: {
      letterSpacing: '0.02em',
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#131210',
          scrollbarColor: 'rgba(234, 227, 214, 0.15) transparent',
          '&::-webkit-scrollbar': { width: '5px' },
          '&::-webkit-scrollbar-track': { background: 'transparent' },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(234, 227, 214, 0.15)',
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: 'rgba(234, 227, 214, 0.25)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontFamily: "'DM Sans', -apple-system, sans-serif",
          borderRadius: 8,
          padding: '9px 20px',
          letterSpacing: '-0.01em',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#1B1916',
          backgroundImage: 'none',
          boxShadow: 'none',
          borderRadius: 10,
          border: '1px solid rgba(234, 227, 214, 0.08)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
          fontFamily: "'DM Sans', -apple-system, sans-serif",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1B1916',
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(234, 227, 214, 0.08)',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#877D72',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#1E1B18',
          border: '1px solid rgba(234, 227, 214, 0.1)',
          borderRadius: '10px',
        },
        arrow: {
          color: '#1E1B18',
        },
      },
    },
  },
});

export default theme;
